// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Index__pc_only___3rGMs","sp_only":"Index__sp_only___tnqMX","projects_container":"Index__projects_container___1ltYS"};